export default "__VITE_PUBLIC_ASSET__9b342bc8__"